// @ts-strict-ignore
import clsx from 'clsx'
import { useCallback, useEffect, useState } from 'react'
import 'swiper/css'
import 'swiper/css/a11y'

import { CardType } from '../../types/types'
import { ClientSliderPagination } from '../slider-pagination/slider-pagination.client'

import { SwiperEl } from './swiper/swiper-el'

import cl from './slider.module.scss'

type SliderProps = {
	className?: string
	type?: CardType
	images: string[]
	alt?: string
	dimmed?: boolean
}

export const Slider = (props: SliderProps) => {
	const { className, images = [], alt = '', dimmed = false, type = 'regular' } = props

	const [swiper, setSwiper] = useState(null)
	const [activeIndex, setActiveIndex] = useState(0)
	const [isDesktop, setIsDesktop] = useState(true)

	const switchToSlide = (index: number) => {
		swiper.slideTo(index)
		setActiveIndex(swiper.realIndex)
	}

	const setToOriginalSlide = () => {
		swiper.slideTo(0)
		setActiveIndex(0)
	}

	const handleSlideChange = useCallback(() => {
		swiper ? setActiveIndex(swiper.realIndex) : null
	}, [swiper])

	useEffect(() => {
		setIsDesktop(window.matchMedia('(min-width: 768px)').matches)
	}, [])

	return (
		<div
			className={clsx(cl.wrapper, cl[type], className, {
				[cl.dimmed]: dimmed
			})}>
			<SwiperEl
				type={type}
				speed={isDesktop ? 0 : 300}
				images={images}
				alt={alt}
				setSwiperInstance={setSwiper}
				handleSlideChange={handleSlideChange}
			/>
			<div className={cl.hoverController} onMouseLeave={setToOriginalSlide}>
				{images.map((_, i) => (
					<div key={i} onMouseOver={() => switchToSlide(i)} />
				))}
			</div>
			<ClientSliderPagination className={cl.pagination} count={images.length} activeIndex={activeIndex} />
		</div>
	)
}
